
<div class="collection-cards-view">
  <align flex collapse-end direction="flex-start">
    <shared-filters
      :filters.sync="filters"
      :query.sync="query"
      :properties="defaultFilters"
      @clear="clearFilters"
    />

    <align small-gap class="collection-options">
      <align small-gap>
        <icon-button
          icon="list"
          :class="{ success: collectionViewType === 'cards' }"
          @click="collectionViewType = 'cards'"
        />

        <icon-button
          icon="view_module"
          :class="{ success: collectionViewType === 'images' }"
          @click="collectionViewType = 'images'"
        />
      </align>

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>
  </align>

  <filter-results
    is-filtering
    :filters="filters"
    :results="numResults"
    @clear="clearFilters"
  />

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results with your filters"
      description="Try adjusting your filters"
    />

    <template>
      <div v-if="collectionViewType === 'images'" class="grid">
        <collection-grid-card
          v-for="card in collectionCards"
          :key="card.id"
          as="router-link"
          :to="{ path: '/collection', query: { ...$route.query, cardId: card.collectionCardId, profile: 'collection' } }"
          :card="card"
        />
      </div>

      <div v-else class="list">
        <card-list-item
          v-for="card in collectionCards"
          :key="card.id"
          as="router-link"
          :to="{ path: '/collection', query: { ...$route.query, cardId: card.collectionCardId, profile: 'collection' } }"
          :card="card"
          :fields="getFields(card)"
          selectable
          :selected="selectedCardIds.includes(card.collectionCardId)"
          @toggleSelected="toggleSelectedCard(card.collectionCardId)"
        >
          <verified-icon
            v-if="card.cardId"
            v-tooltip="{ content: 'Verified Profile', delay: { show: 1500, hide: 100 }, placement: 'bottom' }"
          />

          <collection-card-badges class="medium-up" :card="card" small />
        </card-list-item>
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="nextPage"
      />
    </template>
  </div>
</div>
